<template>
  <div class="label-box">
    <el-card>
      <el-button type="primary" slot="header" size="medium"  @click="jump(), isAdd = 1">{{$t('lang.btn_AddLabel')}}</el-button>
      <el-table :data="labelData" class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange" :height="labelData.length > 0? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <!-- <el-table-column prop="id" :label="$t('lang.lab_id')" width="300px"></el-table-column> -->
        <el-table-column prop="name" :label="$t('lang.lab_labelName')" width="400px"></el-table-column>
        <el-table-column prop="createTime" sortable :label="$t('lang.lab_createLabelTime')">
          <template slot-scope="scope">
            {{ scope.row.createTime | time }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id), isAdd = 0">{{modifyname}}</el-button>
            <el-button class="orange" @click="delete1(scope.row.id)">{{deletename}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
        />
    </el-card>
    <el-dialog
      :visible.sync="show"
      :close-on-click-modal="false"
      center
      top="130px"
      width="800px"
      :title="changeTitle"
      @closed="handleDialogClosed"
    >
        <el-form ref="form" :model="form" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon" :rules="rules" class="form_show">
          <el-form-item :label="$t('lang.lab_labelName')" prop="labelName">
            <el-input v-model="form.labelName" :placeholder="$t('lang.lab_inputLabel')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_taskContent')" prop="content" class="item-width">
              <quill-editor v-model="form.content" ref="myQuillEditor" :options="editorOption" @change="onEditorChange($event)"></quill-editor>
              <br />
              <span class="editorText" v-show="isLength < 10001">{{$t('lang.lab_editor_tip1')}}{{isLength}}{{$t('lang.lab_editor_tip2')}}{{10000-isLength}}{{$t('lang.lab_editor_tip3')}}</span>
              <span class="editorTextTips" v-show="isLength >= 10001">{{$t('lang.lab_editor_tips')}}</span>
            </el-form-item>
        </el-form>
      <div slot="footer">
        <el-button @click="rest('form')" class="cancel">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" :disabled="isDisabled"  @click="editLabel('form')" v-if="isAdd === 0">{{$t('lang.btn_save')}}</el-button>
        <el-button type="primary" :disabled="isDisabled"  @click="addLabel('form')" v-if="isAdd === 1">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:label
 *@Description:标签管理
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-02-21
 */
export default {
  data () {
    return {
      saveData: '', // 存储json字符串
      show: false, // 弹框开关
      pageCount: 0, // 总页数
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      labelData: [], // 标签列表
      multipleSelection: [], // 多选框
      isAdd: 0, // 判断添加该是编辑
      editId: '', // 编辑页面的ID
      changeTitle: '', // 弹框title
      isLength: 0, // 富文本字数长度
      form: {
        labelName: '', // 标签表单的名字
        content: ''
      },
      rules: {
        labelName: [
          { required: true, message: this.$i18n.t('lang.lab_inputLabel'), trigger: 'blur' },
          { max: 10, message: this.$i18n.t('lang.lab_labelNameIs10'), trigger: 'blur' }
        ]
      },
      postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
      deletename: require('@/config/enum').deletename, // 全局删除
      modifyname: require('@/config/enum').modifyname, // 全局编辑
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
            ['blockquote', 'code-block'], // 引用，代码块
            [{ 'header': 1 }, { 'header': 2 }], // 标题，键值对的形式；1、2表示字体大小
            [{ 'list': 'ordered' }, { 'list': 'bullet' }], // 列表
            [{ 'script': 'sub' }, { 'script': 'super' }], // 上下标
            [{ 'indent': '-1' }, { 'indent': '+1' }], // 缩进
            [{ 'direction': 'rtl' }], // 文本方向
            [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }], // 几级标题
            [{ 'color': [] }, { 'background': [] }], // 字体颜色，字体背景颜色
            [{ 'font': [] }], // 字体
            [{ 'align': [] }], // 对齐方式
            ['clean'], // 清除字体样式
            ['image', 'video'] // 上传图片、上传视频
          ]
        },
        theme: 'snow',
        placeholder: this.$i18n.t('lang.lab_text'),
      },
    }
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
       let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.list()
  },
  methods: {
    // 监听关闭dialog
    handleDialogClosed() {
      this.form.labelName = ''
      this.form.content = ''
      this.$refs.form.clearValidate()
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 标签列表
    list() {
      let loading = this.$loading()
      this.$get(
        `/tab?pageSize=${this.pageSize}&pageNo=${this.pageNum}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.labelData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 点击换页
    handleCurrentChange(val) {
      this.pageNum = val
      this.list()
    },
    // 点击更改每页容量
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.list()
    },
    // 弹出添加标签
    jump() {
      this.changeTitle = this.$i18n.t('lang.btn_AddLabel')
      this.form.labelName = ''
      this.form.content = ''
      this.show = true
    },
    // 查询时候调用list方法重置列表
    commit() {
      this.pageNum = 1
      this.list()
    },
    // 根据id删除标签
    delete1(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.$delete(`/tab/` + id).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message({
                type: 'success',
                message: this.$i18n.t('lang.lab_del_success')
              })
              this.commit() // 删除成功后切换page为第一页
            }
          },
          error => {
            loading.close()
            this.$message.error(error) // 与后台沟通一下 是否改为弹框信息内容
          }
        )
      })
      .catch(() => {
        loading.close()
        this.$message({
          type: 'info',
          message: this.$i18n.t('lang.lab_del_can')
        })
      })
    },
    // 点击编辑，出现弹框
    edit(id) {
      this.changeTitle = this.$i18n.t('lang.lab_editLabel')
      let loading = this.$loading()
      this.editId = id
      this.$get(`/tabById/` + id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.form.labelName = res.tab.name
            this.form.content = res.tab.content
          }
          this.form.labelName = this.form.labelName.toString()
          this.show = true
          this.saveData = JSON.stringify(this.form)
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 编辑页面传值保存
    editLabel(from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          let loading = this.$loading()
          let params = {
            name: this.form.labelName,
            content: this.form.content
          }
          this.$patch(`/tab/${this.editId}`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.show = false
                this.list()
              }
              setTimeout(() => {
                loading.close()
              }, 200)
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 添加标签弹框确定
    addLabel(from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          // let formData = new FormData()
          // formData.append('name', this.form.labelName)
          let params = {
            name: this.form.labelName,
            content: this.form.content
          }
          let loading = this.$loading()
          this.$post(`/tab/`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.show = false
                this.list()
              }
              setTimeout(() => {
                loading.close()
              }, 200)
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 弹框点击取消按钮
    rest(form) {
      this.$refs[ form ].resetFields()
      this.form.labelName = ''
    },
    // 内容字数提示
    onEditorChange(event) {
      event.quill.deleteText(10000, 4)
      if (this.form.content === '') {
        this.isLength = 0
      } else {
        this.isLength = event.quill.getLength() - 1
      }
    },
  }
}
</script>

<style scoped  lang='scss'>

</style>